export const SERVICES = {
  page: "services-page",

  // Header
  navHome: "services-nav-home",
  navServicesLogo: "services-nav-logo",
  navConsult: "services-nav-consult",

  // Hero
  hero: "services-hero",
  heroHeadline: "services-hero-headline",
  heroCtaPrimary: "services-hero-cta-primary",
  heroCtaSecondary: "services-hero-cta-secondary",

  // Manifesto marquee
  marquee: "services-marquee",

  // Services grid
  servicesGrid: "services-grid",
  serviceCard: (slug) => `service-card-${slug}`,
  serviceCta: (slug) => `service-cta-${slug}`,

  // Industries
  industriesGrid: "industries-grid",
  industryCard: (slug) => `industry-card-${slug}`,

  // Why us
  whyGrid: "why-grid",
  whyCard: (slug) => `why-card-${slug}`,

  // Process
  processSteps: "process-steps",
  processStep: (n) => `process-step-${n}`,

  // FAQ
  faqList: "faq-list",
  faqItem: (i) => `faq-item-${i}`,

  // Big CTA
  bigCta: "services-big-cta",
  bigCtaBook: "services-big-cta-book",
  bigCtaContact: "services-big-cta-contact",

  // Consultation modal
  modalRoot: "consult-modal",
  modalClose: "consult-modal-close",
  modalName: "consult-name",
  modalEmail: "consult-email",
  modalBusiness: "consult-business",
  modalPhone: "consult-phone",
  modalMessage: "consult-message",
  modalSubmit: "consult-submit",
  modalFormError: "consult-modal-form-error",
  modalSuccess: "consult-modal-success",
};
